// Canonical list of Israeli banks with their official clearing codes (קוד בנק /
// "מספר בנק"). Used for the per-staff bank Select and to print the bank CODE
// (not the name) in the accountant's Excel export.
//
// Codes are the Bank of Israel clearing numbers. The bank Select stores the
// bank NAME (so emails/PDFs stay human-readable); the code is resolved from the
// name only where a number is wanted (Excel).
export const ISRAELI_BANKS = [
    { code: '04', name: 'בנק יהב לעובדי המדינה' },
    { code: '09', name: 'בנק הדואר' },
    { code: '10', name: 'בנק לאומי לישראל' },
    { code: '11', name: 'בנק דיסקונט לישראל' },
    { code: '12', name: 'בנק הפועלים' },
    { code: '13', name: 'בנק אגוד לישראל' },
    { code: '14', name: 'בנק אוצר החייל' },
    { code: '17', name: 'בנק מרכנתיל דיסקונט' },
    { code: '18', name: 'וואן זירו הבנק הדיגיטלי' },
    { code: '20', name: 'בנק מזרחי טפחות' },
    { code: '26', name: 'יובנק' },
    { code: '31', name: 'הבנק הבינלאומי הראשון לישראל' },
    { code: '46', name: 'בנק מסד' },
    { code: '52', name: 'בנק פועלי אגודת ישראל (פאג"י)' },
    { code: '54', name: 'בנק ירושלים' },
    { code: '68', name: 'בנק מימון ישיר' },
];
/** Resolve a bank's clearing code from its (canonical) name. Returns null for an
 *  unknown / free-text legacy value so callers can fall back. */
export function bankCodeByName(name) {
    if (!name)
        return null;
    return ISRAELI_BANKS.find((b) => b.name === name)?.code ?? null;
}
//# sourceMappingURL=banks.js.map